/* PDP "Shop the collection": mobile-only accordion behavior.
   On desktop the columns stay forced-open and the summary is non-interactive
   (handled in CSS). On mobile we hijack the native <details> click to run a
   smooth height transition on the panel. */

(function () {
  var DURATION = 350;
  var EASING = 'cubic-bezier(0.2, 0, 0.15, 1)';
  var mq = window.matchMedia('(max-width: 640px)');
  var section = document.querySelector('.pdp-shop-collection');
  if (!section) return;

  /* Set initial state synchronously (runs while parser is still working
     through the section), so there's no flash on first paint. */
  function syncOpenState() {
    var cols = section.querySelectorAll('.pdp-shop-collection__col');
    cols.forEach(function (d) {
      if (mq.matches) {
        d.removeAttribute('open');
      } else {
        d.setAttribute('open', '');
      }
    });
  }
  syncOpenState();

  /* Animate <details> by manually transitioning panel height.
     Native open/close is instant; we override by intercepting clicks. */
  function animate(details, opening) {
    var panel = details.querySelector('.pdp-shop-collection__panel');
    if (!panel) return;

    if (opening) {
      details.setAttribute('open', '');
      panel.style.transition = 'none';
      panel.style.height = '0px';
      panel.style.overflow = 'hidden';
      void panel.offsetHeight;
      var target = panel.scrollHeight;
      requestAnimationFrame(function () {
        panel.style.transition = 'height ' + DURATION + 'ms ' + EASING;
        panel.style.height = target + 'px';
      });
    } else {
      panel.style.transition = 'none';
      panel.style.height = panel.scrollHeight + 'px';
      panel.style.overflow = 'hidden';
      void panel.offsetHeight;
      requestAnimationFrame(function () {
        panel.style.transition = 'height ' + DURATION + 'ms ' + EASING;
        panel.style.height = '0px';
      });
    }

    function done(e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      panel.style.transition = '';
      panel.style.height = '';
      panel.style.overflow = '';
      if (!opening) details.removeAttribute('open');
    }
    panel.addEventListener('transitionend', done);
  }

  /* Mobile-only: take over summary clicks and run our animation.
     Desktop summary has pointer-events: none from CSS, so default
     toggle never runs there. */
  section.querySelectorAll('.pdp-shop-collection__col-heading').forEach(function (summary) {
    summary.addEventListener('click', function (e) {
      if (!mq.matches) return;
      e.preventDefault();
      var details = summary.closest('.pdp-shop-collection__col');
      if (!details) return;
      var opening = !details.hasAttribute('open');
      animate(details, opening);
    });
  });

  /* Re-sync on viewport changes (e.g. rotating phone, devtools resize). */
  function onMqChange() {
    syncOpenState();
  }
  if (mq.addEventListener) mq.addEventListener('change', onMqChange);
  else if (mq.addListener) mq.addListener(onMqChange);
})();
